var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set-flex n-wrap set-flex-y-center"},[_c('span',{staticClass:"status-cell"},[_vm._v(" "+_vm._s(_vm.$t('gifts.payed'))+" ")]),_c('span',{staticClass:"rbi-check"})])}
var staticRenderFns = []

export { render, staticRenderFns }